(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('progressHub', progressHubFactory);

    progressHubFactory.$inject = ['hub', app.modules.common.constants.appsettings];
    function progressHubFactory(hub, ggSettings) {
        return function progressHub() {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.signalR;
            var result = hub(apipath, 'progressHub');
            result.subscribe = subscribe;
            result.unsubscribe = unsubscribe;
            return result;

            function subscribe(name) {
                return this.invoke('subscribe', name);
            }

            function unsubscribe(name) {
                return this.invoke('unsubscribe', name);
            }
        }
    }
})();